import { Response, WareHouse } from '@/types';
import { BaseApiService } from './base-service';

export class WarehousesService extends BaseApiService {
  private base_path = 'warehouses';

  async get_warehouses(organization_id: string | number): Promise<Response<WareHouse[]>> {
    const { data } = await this.http_client.get<Response<WareHouse[]>>(`${this.base_path}/${organization_id}`);

    return data;
  }
}
